import * as maxCheckedItems from './datiq-checklist-max-number.validator';
import * as minCheckedItems from './datiq-checklist-min-number.validator';

const DatiqChecklistValidators = {
    ...maxCheckedItems,
    ...minCheckedItems,
};

export { DatiqChecklistValidators };
